module.exports = __webpack_public_path__ + "static/media/4.8_preview.043e3641.png";